import { ActionType, createAction } from "typesafe-actions";
import { SecurityBwicStatisticsSummary } from "../../types/security/SecurityBwicStatisticsSummary";

const request = createAction(
    'entities/securityBwicHistory/REQUEST',
    resolve => (securityId: number) => resolve({ securityId })
);
const requestResult = createAction(
    'entities/securityBwicHistory/REQUEST_RESULT',
    resolve => (securityId: number, bwicHistory: SecurityBwicStatisticsSummary) => resolve({ securityId, bwicHistory })
);
const requestFailure = createAction(
    'entities/securityBwicHistory/REQUEST_FAILURE',
    resolve => (securityId: number) => resolve({ securityId })
);

const reset = createAction('entities/securityBwicHistory/RESET');

export type TSecurityBwicHistoryActions = ActionType<(typeof securityBwicHistoryActions)[keyof typeof securityBwicHistoryActions]>;

export const securityBwicHistoryActions = {
    request,
    requestResult,
    requestFailure,
    reset
}